export default [
  {
    path: '/admin',
    name: 'admin',
    meta: {
      layout: "default",
      auth: false,
      global: true,
      scaleAdminOnly: true,
      breadcrumb: [{ label: 'Scale Admin' }],
    },
    component: () => import('../pages/admin/Default.vue')
  },
  {
    path: '/admin/users/:id',
    name: 'admin/user-detail',
    meta: {
      layout: "default",
      auth: false,
      global: true,
      scaleAdminOnly: true,
      breadcrumb: [{ label: 'Scale Admin', to: { name: 'admin' } }, { label: 'User Detail' }],
    },
    component: () => import('../pages/admin/UserDetail.vue')
  }
]
